import PropTypes from 'prop-types'
import {USER_TYPE_PARTNER, USER_TYPE_REFERRER} from '@/lib/user'
import ResultLogin from '@/components/shared/Result/Login'
import Spinner from '@/components/layout/Spinner'
import resultStyles from '@/styles/molecules/Result/styles.module.css'

const Wrapper = ({partnerContent, content, userProfile, userType}) => {
  return userProfile !== undefined ? (
    userProfile ? (
      userProfile.type === userType ? (
        partnerContent
      ) : (
        content
      )
    ) : (
      <ResultLogin />
    )
  ) : (
    <div className={resultStyles.ecTemplateListings__result}>
      <Spinner />
    </div>
  )
}

Wrapper.propTypes = {
  partnerContent: PropTypes.object,
  content: PropTypes.object,
  userProfile: PropTypes.object,
  userType: PropTypes.oneOf([USER_TYPE_PARTNER, USER_TYPE_REFERRER])
}

export default Wrapper
